<template>
  <div class="step-content">
    <div class="step-item-main" v-if="step === 0">
      <div class="user-preview" :style="{backgroundImage: `url('${backgroundUrl}')`}"></div>
      <div class="tab-list">
        <div v-for="(item, index) in tabList" :key="index" :class="['tab-item', item.type, item.type === activeTab ? 'active' : '' ]" @click="handleClickTab(item.type)"></div>
      </div>
      <div v-if="activeTab === 'gender'" class="select-gender-box">
        <div :class="['gender-item', 'boy', gender === 0 ? 'active' : '']" @click="handleClickGender(0)"></div>
        <div :class="['gender-item', 'girl', gender === 1 ? 'active' : '']" @click="handleClickGender(1)"></div>
      </div>
      <div v-if="activeTab === 'hair'" class="select-hair-box">
        <div v-for="item in 3" :class="['hair-item', `${gender === 0 ? 'boy' : 'girl'}-hair${item}`, hair === item ? 'active' : '']" :key="item" @click="handleClickHair(item)"></div>
      </div>
      <div v-if="activeTab === 'suit'" class="select-suit-box">
        <div v-for="item in 3" :class="['suit-item', `${gender === 0 ? 'boy' : 'girl'}-suit${item}`, suit === item ? 'active' : '']" :key="item" @click="handleClickSuit(item)"></div>
      </div>
      <div v-if="activeTab === 'color'" class="select-color-box">
        <div v-for="item in colorList" :class="['color-item', item, color === item ? 'active' : '']" :key="item" @click="handleClickColor(item)"></div>
      </div>
      <div class="hint">
        点击<span> OK </span>即可保存形象
      </div>
    </div>
    <div class="step-item-main name-box" v-if="step === 1">
      <img src="https://files.wondercv.com/Game/character/H5/dialog1.png" width="273" height="81"/>
      <img :src="backgroundUrl" width="126" height="170" class="preview-image"/>
      <div class="input-box">
        <input v-model="username"/>
      </div>
      <div class="btn-box" @click="handleClickSubmit"></div>
    </div>
  </div>
</template>

<script>
  const ColorToNum = {
    'brown': 0,
    'gray': 1,
    'red': 2
  }
  const NumToColor = {
    0: "brown",
    1: "gray",
    2: "red"
  }
  export default {
    name: "identity-select",
    props: {
      step: {
        type: Number,
        default: 0
      },
      initInfo: {
        type:Object,
        default: () => {
          return {

          }
        }
      }
    },
    data(){
      return {
        activeTab: "gender",
        tabList: [
          {type: "gender"},
          {type: "hair"},
          {type: "suit"},
          {type: "color"}
        ],
        gender: 0,
        hair: 1,
        suit: 1,
        color: "brown",
        colorList: ['brown', 'gray', 'red'],
        username: "大傻慧"
      }
    },
    computed: {
      backgroundUrl(){
        let gender = this.gender === 0 ? 'boy' : 'girl'
        let hair = 'hari' + this.hair
        let color = this.color
        let suit = (this.suit === 3 || this.suit === 4) ? (this.gender === 0 ? 'suit4' : 'suit3')  : `suit${this.suit}`
        let url = `https://files.wondercv.com/Game/character/${gender}/${hair}/${color}/${suit}.png`
        return url
      }
    },
    created() {
      this.gender = this.initInfo.gender || 0
      this.username = this.initInfo.username || "大傻慧"
      this.hair = this.initInfo.hair ? (this.initInfo.hair_style + 1) : 1
      this.suit = this.initInfo.suit ? (this.initInfo.suit + 1) : 1
      this.color = NumToColor[this.initInfo.hair_color] || 'brown'
    },
    methods: {
      handleClickTab(type){
        this.activeTab = type
        this.onChangeUserInfo()
      },
      handleClickGender(value){
        this.gender = value
        this.onChangeUserInfo()
      },
      handleClickHair(value){
        this.hair = value
        this.onChangeUserInfo()
      },
      handleClickSuit(value){
        this.suit = value
        this.onChangeUserInfo()
      },
      handleClickColor(value){
        this.color = value
        this.onChangeUserInfo()
      },
      onChangeUserInfo(){
        let userInfo = {
          gender: this.gender,
          hair_style: this.hair,
          suit: this.suit,
          hair_color: ColorToNum[this.color],
          username: this.username
        }
        this.$emit("on-change-user", userInfo)
      },
      handleClickSubmit(){
        let userInfo = {
          gender: this.gender,
          hair_style: this.hair - 1,
          suit: this.suit - 1,
          hair_color: ColorToNum[this.color],
          username: this.username
        }
        this.$emit("on-save", userInfo)
      }
    }
  }
</script>

<style scoped lang="scss">
.step-content{
  width: 100%;
  height: 100%;
  background-color: #fff;
  .step-item-main{
    width: 100%;
    height: 100%;
    padding-top: 30px;
    .user-preview{
      width: 156px;
      height: 210px;
      margin: 0 auto 19px;
      background-size: 100%;
      background-repeat: no-repeat;
    }
    .tab-list{
      display: flex;
      align-items: center;
      justify-content: center;
      .tab-item{
        background-size: 100%;
        background-repeat: no-repeat;
        width: 63px;
        height: 36px;
        margin: 0 6px;
        &.gender{
          background-image: url("https://files.wondercv.com/Game/character/H5/gender_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/gender_press.png");
          }
        }
        &.hair{
          background-image: url("https://files.wondercv.com/Game/character/H5/hair_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/hair_press.png");
          }
        }
        &.suit{
          background-image: url("https://files.wondercv.com/Game/character/H5/suit_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/suit_press.png");
          }
        }
        &.color{
          background-image: url("https://files.wondercv.com/Game/character/H5/color_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/color_press.png");
          }
        }
      }
    }
    .select-gender-box{
      margin-top: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      .gender-item{
        width: 138px;
        height: 86px;
        margin: 0 6px;
        background-size: 100%;
        background-repeat: no-repeat;
        &.boy{
          background-image: url("https://files.wondercv.com/Game/character/H5/boy_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/boy_press.png");
          }
        }
        &.girl{
          background-image: url("https://files.wondercv.com/Game/character/H5/girl_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/girl_press.png");
          }
        }
      }
    }
    .select-hair-box{
      margin-top: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      .hair-item{
        width: 86px;
        height: 86px;
        margin: 0 7px;
        background-size: 100%;
        background-repeat: no-repeat;
        &.boy-hair1{
          background-image: url("https://files.wondercv.com/Game/character/H5/boy_hair1_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/boy_hair1_press.png");
          }
        }
        &.boy-hair2{
          background-image: url("https://files.wondercv.com/Game/character/H5/boy_hair2_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/boy_hair2_press.png");
          }
        }
        &.boy-hair3{
          background-image: url("https://files.wondercv.com/Game/character/H5/boy_hair3_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/boy_hair3_press.png");
          }
        }
        &.girl-hair1{
          background-image: url("https://files.wondercv.com/Game/character/H5/girl_hair1_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/girl_hair1_press.png");
          }
        }
        &.girl-hair2{
          background-image: url("https://files.wondercv.com/Game/character/H5/girl_hair2_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/girl_hair2_press.png");
          }
        }
        &.girl-hair3{
          background-image: url("https://files.wondercv.com/Game/character/H5/girl_hair3_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/girl_hair3_press.png");
          }
        }
      }
    }
    .select-suit-box{
      margin-top: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      .suit-item{
        width: 86px;
        height: 86px;
        margin: 0 7px;
        background-size: 100%;
        background-repeat: no-repeat;
        &.boy-suit1{
          background-image: url("https://files.wondercv.com/Game/character/H5/suit1_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/suit1_press.png");
          }
        }
        &.boy-suit2{
          background-image: url("https://files.wondercv.com/Game/character/H5/suit2_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/suit2_press.png");
          }
        }
        &.boy-suit3{
          background-image: url("https://files.wondercv.com/Game/character/H5/suit4_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/suit4_press.png");
          }
        }
        &.girl-suit1{
          background-image: url("https://files.wondercv.com/Game/character/H5/suit1_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/suit1_press.png");
          }
        }
        &.girl-suit2{
          background-image: url("https://files.wondercv.com/Game/character/H5/suit2_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/suit2_press.png");
          }
        }
        &.girl-suit3{
          background-image: url("https://files.wondercv.com/Game/character/H5/suit3_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/suit3_press.png");
          }
        }
      }
    }
    .select-color-box{
      margin-top: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      .color-item{
        width: 86px;
        height: 86px;
        margin: 0 7px;
        background-size: 100%;
        background-repeat: no-repeat;
        &.brown{
          background-image: url("https://files.wondercv.com/Game/character/H5/brown_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/brown_press.png");
          }
        }
        &.gray{
          background-image: url("https://files.wondercv.com/Game/character/H5/gray_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/gray_press.png");
          }
        }
        &.red{
          background-image: url("https://files.wondercv.com/Game/character/H5/red_normal.png");
          &.active{
            background-image: url("https://files.wondercv.com/Game/character/H5/red_press.png");
          }
        }
      }
    }
    .hint{
      margin-top: 24px;
      text-align: center;
      font-size: 14px;
      font-family: IPix;
      color: #606060;
      line-height: 15px;
      span{
        color: #F5B34E;
      }
    }
    &.name-box{
      padding-top: 33px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .preview-image{
        margin: 12px 0 20px;
      }
      .input-box{
        width: 273px;
        height: 48px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-image: url("https://files.wondercv.com/Game/character/H5/input_normal.png");
        margin-bottom: 14px;
        & > input{
          border: none;
          outline: none;
          text-align: center;
          width: 100%;
          height: 100%;
          background-color: transparent;
          font-size: 20px;
          line-height: 22px;
        }
      }
      .btn-box{
        width: 273px;
        height: 48px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-image: url("https://files.wondercv.com/Game/character/H5/button_normal.png");
        margin-bottom: 14px;
      }
    }
  }
}
</style>
